import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lecture",
  "use": "icon-lecture-usage",
  "viewBox": "0 0 1076 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1076 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-lecture\"><path d=\"M11.006 955.214H1065.73V1024H11.006zM1076.278 846.99H0V0h1076.278zM67.41 779.579h941.456V67.411H67.411z\" p-id=\"25900\" fill=\"#e7ebee\" /><path d=\"M719.964 423.724L448.03 240.294v366.86l271.935-183.43z\" p-id=\"25901\" fill=\"#e7ebee\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol